import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { makeAuthenticatedRequest } from "../utils/api";
import { decrypt, encrypt } from "../utils/cryptoUtils"; // Import encryption utilities
import { useDispatch, useSelector } from "react-redux";
import { ProfileSuccess } from "../redux/ProfileSlice"; // Corrected import
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AxiosError } from "../components/sessionexpiry";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { Link } from "react-router-dom";

const Profile = ({ isSidebarCollapsed, isMobile }) => {
  // const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const profileDataFromRedux = useSelector((state) => state.profile.data);
  const [activeSection, setActiveSection] = useState("profile");
  const [loader, setLoader] = useState(false);
  const [responseData, setResponseData] = useState(null);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Initialize profileData state with default values or data from Redux
  const [profileData, setProfileData] = useState({
    mid: "",
    name: "",
    email: "",
    mobile: "",
    businessType: "",
    businessName: "",
    registerOn: "",
    profile_pic: "",
  });

  // const toggleSidebar = () => {
  //   setIsSidebarCollapsed(!isSidebarCollapsed);
  // };

  const loginScreen = useSelector((state) => state.login?.loginScreen || []);
  const profilePic = loginScreen.length > 0 ? loginScreen[1].profile_pic : "";

  console.log("Profile Pic:", profilePic);

  // Default Profile Image URL (Use your placeholder image)
  const defaultImage = `https://merchant-image.jantapays.com/images${profilePic.startsWith("/") ? profilePic : profilePic}`;

  // Set initial profile image from profileData or default
  const [profileImage, setProfileImage] = useState(defaultImage);

  const token = sessionStorage.getItem("token");
  const API_URL = `https://merchant-api.jantapays.com/auth/${profileData?.mid}/upload-profile-pic`;

  // Handle file selection
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (!allowedTypes.includes(file.type)) {
        toast.error("Only JPG, JPEG, and PNG files are allowed.");
        return;
      }

      if (file.size > 10 * 1024 * 1024) {
        toast.error("File size should be less than 2MB.");
        return;
      }

      setProfileImage(URL.createObjectURL(file)); // Show preview before upload
      uploadImage(file);
    }
  };

  // Upload the image to the server
  const uploadImage = async (file) => {
    if (!token) {
      toast.error("Authentication required. Please log in.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(API_URL, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        toast.success("Profile picture uploaded successfully!");
        if (response.data.filePath) {
          setProfileImage(
            `https://merchant-image.jantapays.com/images/${response.data.filePath}`
          );
        }
      } else {
        toast.error("Failed to upload profile picture.");
      }
    } catch (error) {
      AxiosError(navigate, error);
      console.error("Upload error:", error);
      toast.error("An error occurred while uploading.");
    }
  };

  // Toggle Button
  const [isTwoFactorEnabled, setIsTwoFactorEnabled] = useState(false);

  const toggleTwoFactor = () => {
    setIsTwoFactorEnabled(!isTwoFactorEnabled);
  };

  // Password Validation Part
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [errors, setErrors] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const validateForm = () => {
    let valid = true;
    let newErrors = {
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    };

    if (!currentPassword) {
      newErrors.currentPassword = "Current password is required.";
      valid = false;
    }else if (
      !/^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
        currentPassword
      )
    ) {
      newErrors.currentPassword =
        "Password must be at least 8 characters long and include at least one uppercase letter, one number, and one special character.";
      valid = false;
    }

    if (!newPassword) {
      newErrors.newPassword = "New password is required.";
      valid = false;
    } else if (
      !/^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
        newPassword
      )
    ) {
      newErrors.newPassword =
        "Password must be at least 8 characters long and include at least one uppercase letter, one number, and one special character.";
      valid = false;
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Please re-enter the new password.";
      valid = false;
    } else if (confirmPassword !== newPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      try {
        // Convert email and password to a JSON string
        const jsonData = JSON.stringify({
          cur_password: currentPassword,
          new_password: confirmPassword,
        });

        // Encrypt the JSON string
        const encrypted = encrypt(jsonData);

        // Log the encrypted and decrypted data for debugging
        console.log("Encrypted Data:", encrypted);
        console.log("Decrypted Data:", decrypt(encrypted));

        // Call the login API
        const response = await makeAuthenticatedRequest(
          "PUT",
          "/auth/update",
          { encrypted },
          navigate
        );

        const decryptdata = decrypt(response);
        const fixedString = decryptdata.replace(/\\"/g, '"');

        // Convert to array
        const jsonArray = JSON.parse(fixedString);

        console.log(jsonArray);

        // Display the welcome message to the user
        if (jsonArray.Status === "200") {
          toast.success("Password update succesfully");
          // alert(jsonArray.token);
          // console.log("Stored data:", jsonArray.token); // Log the entire response
          window.location.reload(); // Refresh the pages
          navigate("/Profile");
        } else {
          setError(response.token);
        }
      } catch (err) {
        // Log the error for debugging
        AxiosError(navigate, error);
        console.error("Login Error:", err.message);

        // Display the error message to the user
        setError(err.message);
      }
    }
  };

  useEffect(() => {
    const postData = async () => {
      try {
        const accessToken = sessionStorage.getItem("token"); // Retrieve token

        const requestData = JSON.stringify({
          Dname: "merchant",
          Tname: "users u",
          Cname: [
            "u.id",
            "name",
            "email",
            "business_name",
            "mobile",
            "profile_pic",
            "bt.business_type",
            "u.created_at",
          ], // Updated field names
          Jtype: "inner join",
          Jcondition: {
            "merchant.business_type bt": "u.business_type=bt.id",
          },
          Where: [
            { 
              column: "accesstoken",
              operator: "=",
              value: accessToken 
            },
          ],
          Limit: "10",
          Offset: "0",
        });

        const encrypted = encrypt(requestData);

        const data = await makeAuthenticatedRequest(
          "POST",
          "/fetch",
          { encrypted },
          navigate
        );
        const decryptdata = decrypt(data);
        const fixedString = decryptdata.replace(/\\"/g, '"');

        // Convert to array
        const jsonArray = JSON.parse(fixedString);

        dispatch(ProfileSuccess(jsonArray)); // Pass the entire response

        if (jsonArray.length > 0) {
          setProfileData({
            mid: jsonArray[1]["u.id"] || "",
            profile_pic: jsonArray[1].profile_pic || "",
            name: jsonArray[1].name || "",
            email: jsonArray[1].email || "",
            mobile: jsonArray[1].mobile || "",
            businessType: jsonArray[1]["bt.business_type"] || "", // Corrected syntax
            businessName: jsonArray[1].business_name || "",
            registerOn: jsonArray[1]["u.created_at"]?.split(" ")[0] || "", // Extract date part
          });
        }

        setResponseData(jsonArray);
      } catch (err) {
        AxiosError(navigate, error);
        setError(err.message);
      }
    };

    postData();
  }, [dispatch]);

  return (
    <div className={`bg-[#F4F5FA] min-h-screen`}>
      {/* <Header
        toggleSidebar={toggleSidebar}
        isSidebarCollapsed={isSidebarCollapsed}
      />
      <Sidebar
        isSidebarCollapsed={isSidebarCollapsed}
        toggleSidebar={toggleSidebar}
      /> */}

      <main className="main-content">
        <div
          className={`mx-auto p-4 md:p-4 transition-all duration-300 ${
            isSidebarCollapsed && !isMobile
              ? "lg:ml-20"
              : !isSidebarCollapsed && !isMobile
              ? "lg:ml-[270px]"
              : "ml-0"
          }`}
        >
         
         <div className="mb-6 flex flex-wrap items-center justify-between ml-4">
            <div>
              <h2 className="text-xl font-semibold text-gray-800">Profile</h2>
              {/* <p className="text-sm text-gray-600 mt-1">Manage your account payouts and transactions</p> */}
            </div>
            <nav>
              <ol className="flex items-center space-x-2 text-sm">
                <li>
                  <Link
                    className="flex items-center text-gray-500 hover:text-[#299F1F] transition-colors"
                    to="/dashboard"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                      />
                    </svg>
                    Home
                  </Link>
                </li>
                <li className="text-gray-400">/</li>
                <li className="font-medium text-gray-800">Profile</li>
              </ol>
            </nav>
          </div>

          <div className=" md:p-6 md:flex md:space-x-6">
            <div className="md:w-1/3 lg:w-80 mb-2">
              <div className="rounded-2xl border border-gray-200 bg-white p-5">
                <div className="flex flex-col items-center space-y-3">
                  {/* <!-- Profile Picture Upload --> */}
                  <label
                    htmlFor="profile-pic"
                    className="relative z-0 cursor-pointer w-40 h-40 border border-gray-300 rounded-full group"
                  >
                    <input
                      type="file"
                      id="profile-pic"
                      className="hidden"
                      accept="image/*"
                      onChange={handleImageChange} // Use React handler
                    />
                    {profileImage ? (
                      <img
                        src={profileImage}
                        alt="Profile Picture"
                        className="w-40 h-40 rounded-full border border-gray-300 object-cover"
                      />
                    ) : (
                      <div className="w-40 h-40 rounded-full bg-gray-300 flex items-center justify-center text-xl font-semibold text-black">
                        Profile Pic
                      </div>
                    )}
                    <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center text-white text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-full">
                      Upload
                    </div>
                  </label>
                </div>

                <div className="px-5 py-4 sm:px-6 sm:py-5 text-center">
                  <h1 className="text-xl font-medium text-gray-800">
                    {profileData.name}
                  </h1>
                  <h2 className="mt-2 text-gray-600">
                    {profileData.businessName} ( {profileData.mid} )
                  </h2>
                </div>
              </div>
            </div>

            <div className="flex-1">
              <div className="rounded-2xl border border-gray-200 bg-white">
                <div className="px-5 py-4 sm:px-6 sm:py-5 flex gap-3 border-b border-gray-100">
                  <h3
                    className={`text-lg cursor-pointer p-1 w-[150px] text-center ${
                      activeSection === "profile"
                        ? "bg-white border border-[#27ae60] text-[#27ae60] hover:bg-[#299F1F] hover:text-white font-semibold py-2 px-6 rounded-lg transition shadow-sm"
                        : ""
                    }`}
                    onClick={() => setActiveSection("profile")}
                  >
                    Profile
                  </h3>
                  <h3
                    className={`text-lg cursor-pointer p-1 w-[150px] text-center ${
                      activeSection === "security"
                        ? "bg-white border border-[#27ae60] text-[#27ae60] hover:bg-[#299F1F] hover:text-white font-semibold py-2 px-6 rounded-lg transition shadow-sm"
                        : ""
                    }`}
                    onClick={() => setActiveSection("security")}
                  >
                    Security
                  </h3>
                </div>

                {activeSection === "profile" && (
                  <div id="profile-section" className="p-5 sm:p-6">
                    <div className="grid lg:grid-cols-2 gap-6">
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Name<span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          id="Name"
                          placeholder="Name"
                          value={profileData.name}
                          onChange={(e) =>
                            setProfileData({
                              ...profileData,
                              name: e.target.value,
                            })
                          }
                          className="mt-2 w-full px-4 py-2 border rounded-md"
                          disabled
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Email<span className="text-red-500">*</span>
                        </label>
                        <input
                          type="email"
                          id="Email"
                          placeholder="Email"
                          value={profileData.email}
                          onChange={(e) =>
                            setProfileData({
                              ...profileData,
                              email: e.target.value,
                            })
                          }
                          className="mt-2 w-full px-4 py-2 border rounded-md"
                          disabled
                        />
                      </div>
                    </div>
                    <div className="grid lg:grid-cols-2 gap-6 mt-5">
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Mobile No<span className="text-red-500">*</span>
                        </label>
                        <input
                          type="tel"
                          id="Mobile"
                          placeholder="Mobile"
                          maxLength="10"
                          value={profileData.mobile}
                          onChange={(e) =>
                            setProfileData({
                              ...profileData,
                              mobile: e.target.value,
                            })
                          }
                          className="mt-2 w-full px-4 py-2 border rounded-md"
                          disabled
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Business Type<span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          id="BusinessType"
                          placeholder="Business Type"
                          value={profileData.businessType}
                          onChange={(e) =>
                            setProfileData({
                              ...profileData,
                              businessType: e.target.value,
                            })
                          }
                          className="mt-2 w-full px-4 py-2 border rounded-md"
                          disabled
                        />
                      </div>
                    </div>
                    <div className="grid lg:grid-cols-2 gap-6 mt-5">
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Business Name<span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          id="BusinessName"
                          placeholder="Business Name"
                          value={profileData.businessName}
                          onChange={(e) =>
                            setProfileData({
                              ...profileData,
                              businessName: e.target.value,
                            })
                          }
                          className="mt-2 w-full px-4 py-2 border rounded-md"
                          disabled
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Register On<span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          id="RegisterOn"
                          value={profileData.registerOn}
                          onChange={(e) =>
                            setProfileData({
                              ...profileData,
                              registerOn: e.target.value,
                            })
                          }
                          className="mt-2 w-full px-4 py-2 border rounded-md"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                )}

                {activeSection === "security" && (
                  <div className="p-5 sm:p-6">
                    <div className="flex py-3">
                      <p className="text-xl text-[#299F1F]">
                        Two-Factor Authentication
                      </p>

                      {/* <!-- Toggle Switch --> */}
                      <label className="relative inline-flex items-center cursor-pointer ml-10">
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          checked={isTwoFactorEnabled}
                          onChange={toggleTwoFactor}
                        />
                        <div className="w-12 h-6 bg-gray-300 peer-checked:bg-[#299F1F] rounded-full transition-all duration-300 relative">
                          <div
                            className={`w-5 h-5 bg-white rounded-full absolute top-0.5 transition-all duration-300 ${
                              isTwoFactorEnabled ? "left-6" : "left-1"
                            }`}
                          ></div>
                        </div>
                      </label>
                    </div>

                    <hr className="mt-9" />

                    <div className="mt-5">
                      <h1 className="text-lg text-[#299F1F]">
                        Change Password
                      </h1>

                      <form onSubmit={handleSubmit}>
                        <div className="grid lg:grid-cols-2 gap-6 mt-9">
                          {/* Current Password */}
                          <div className="relative">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Type your Password
                              <span className="text-red-500">*</span>
                            </label>
                            <input
                              type={showPassword ? 'text' : 'password'}
                              value={currentPassword}
                              onChange={(e) =>
                                setCurrentPassword(e.target.value)
                              }
                              placeholder="Type Your Password"
                              // className="mt-2 w-full px-4 py-2 border rounded-md"
                              className={`w-full px-4 py-2 rounded-md border ${
                                errors.currentPassword
                                  ? "border-red-500"
                                  : "border-gray-300"
                              } focus:outline-none focus:ring-2 placeholder:text-sm text-sm ${
                                errors.currentPassword
                                  ? "focus:ring-red-400"
                                  : "focus:ring-[#299F1F]"
                              }`}
                            />
                            <div
                              className="absolute right-3 top-8 text-xl text-gray-600 cursor-pointer"
                              onClick={() => setShowPassword((prev) => !prev)}
                            >
                              {showPassword ? (
                                <AiOutlineEyeInvisible />
                              ) : (
                                <AiOutlineEye />
                              )}
                            </div>
                            {errors.currentPassword && (
                              <p className="text-red-500 text-sm mt-1">
                                {errors.currentPassword}
                              </p>
                            )}
                          </div>

                          {/* New Password */}
                          <div className="relative">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              New Password
                              <span className="text-red-500">*</span>
                            </label>
                            <input
                              type={showNewPassword ? 'text' : 'password'}
                              value={newPassword}
                              onChange={(e) => setNewPassword(e.target.value)}
                              placeholder="New Password"
                              // className="mt-2 w-full px-4 py-2 border rounded-md"
                              className={`w-full px-4 py-2 rounded-md border ${
                                errors.newPassword
                                  ? "border-red-500"
                                  : "border-gray-300"
                              } focus:outline-none focus:ring-2 placeholder:text-sm text-sm ${
                                errors.newPassword
                                  ? "focus:ring-red-400"
                                  : "focus:ring-[#299F1F]"
                              }`}
                            />
                            <div
                              className="absolute right-3 top-8 text-xl text-gray-600 cursor-pointer"
                              onClick={() => setShowNewPassword((prev) => !prev)}
                            >
                              {showNewPassword ? (
                                <AiOutlineEyeInvisible />
                              ) : (
                                <AiOutlineEye />
                              )}
                            </div>
                            {errors.newPassword && (
                              <p className="text-red-500 text-sm mt-1">
                                {errors.newPassword}
                              </p>
                            )}
                          </div>

                          {/* Confirm New Password */}
                          <div className="relative">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Re-Type New Password
                              <span className="text-red-500">*</span>
                            </label>
                            <input
                               type={showConfirmPassword ? 'text' : 'password'}
                              value={confirmPassword}
                              onChange={(e) =>
                                setConfirmPassword(e.target.value)
                              }
                              placeholder="Re-Type New Password"
                              // className="mt-2 w-full px-4 py-2 border rounded-md"
                              className={`w-full px-4 py-2 rounded-md border ${
                                errors.confirmPassword
                                  ? "border-red-500"
                                  : "border-gray-300"
                              } focus:outline-none focus:ring-2 placeholder:text-sm text-sm ${
                                errors.confirmPassword
                                  ? "focus:ring-red-400"
                                  : "focus:ring-[#299F1F]"
                              }`}
                            />
                            <div
                              className="absolute right-3 top-8 text-xl text-gray-600 cursor-pointer"
                              onClick={() => setShowConfirmPassword((prev) => !prev)}
                            >
                              {showConfirmPassword ? (
                                <AiOutlineEyeInvisible />
                              ) : (
                                <AiOutlineEye />
                              )}
                            </div>
                            {errors.confirmPassword && (
                              <p className="text-red-500 text-sm mt-1">
                                {errors.confirmPassword}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Submit Button */}
                        <div className="flex justify-end w-full">
                          <button
                            type="submit"
                            className="text-sl w-20 flex justify-center bg-[#299F1F] text-white py-2 p-3 rounded-md mt-4"
                          >
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default Profile;
